<script setup lang="ts">
import { connectSortBy } from 'instantsearch.js/es/connectors';
import {
  SortByConnectorParams,
  SortByItem,
  SortByWidgetDescription,
} from 'instantsearch.js/es/connectors/sort-by/connectSortBy';
import { computed } from 'vue';

import Radio from '@/components/base/form/Radio.vue';
import BaseBodyText from '@/components/base/typography/BaseBodyText.vue';
import { useWidget } from '@/composables/instant-search/useWidget';

const props = defineProps<{ items: SortByItem[] }>();

const widgetParams = computed<SortByConnectorParams>(() => ({ items: props.items }));
const { state } = useWidget<SortByWidgetDescription, SortByConnectorParams>(
  { connector: connectSortBy },
  widgetParams,
);
const refine = (value: string) => {
  state.value?.refine(value);
};
</script>

<template>
  <div v-if="state">
    <Radio
      v-for="item in state.options"
      v-model="state.currentRefinement"
      :key="item.value"
      :value="item.value"
      @click="refine(item.value)"
      class="my-2"
    >
      <BaseBodyText
        :class="item.value === state.currentRefinement ? 'font-semibold' : 'font-normal'"
      >
        {{ item.label }}
      </BaseBodyText>
    </Radio>
  </div>
</template>
